import { useEffect, useState } from "react";
import { useLoader } from "../context/loaderContext";
import Layout from "../layout/layout";
import axios from "axios";
import { Appid, BaseUrl, Imei, LoginTypeID, SerialNo, Version } from "../enum/enum";
import { useAuth } from "../context/authContext";
import moment from "moment";

const DirectTeam = () => {
    const { showLoader, hideLoader } = useLoader();
    const {
        token,
        sessionId,
        userId,
    } = useAuth();

    const customFieldLabels = {
        DeActiveDirect: 'Deactive Direct',
        TotalDeActiveTeam: 'Total Deactive Team',
    };

    const [directTeam, setDirectTeam] = useState([]);
    const [status, setStatus] = useState("All");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const getDirectTeam = async () => {
        try {
            const url = `${BaseUrl}Dashboard/DirectMemberList`;

            const obj = {
                "appSession": {
                    "appid": Appid,
                    "imei": Imei,
                    "loginTypeID": LoginTypeID,
                    "regKey": "",
                    "serialNo": SerialNo,
                    "session": token,
                    "sessionID": sessionId,
                    "uid": 0,
                    "userID": userId,
                    "version": Version
                },
                "request": {
                    "FromDate": moment(fromDate || new Date()).format("DD-MMM-YYYY"),
                    "LevelNo": 1,
                    "Status": status,
                    "ToDate": toDate ? moment(toDate).format("DD-MMM-YYYY")
                        : moment(new Date(), "DD-MMM-YYYY").format("DD-MMM-YYYY"),
                    "Leg": "All",
                    "SearchType": "0",
                    "IsRecent": false
                }
            }

            showLoader();

            const res = await axios.post(url, obj);

            if (res.data?.statuscode == 1) {
                setDirectTeam(res.data.data || []);
            } else {
                setDirectTeam([]);
            }

            hideLoader();
        } catch (e) {
            hideLoader();
            console.log(e.message);
        }
    }

    const formatFieldLabel = (field) => {
        return customFieldLabels[field] || field.replace(/([a-z])([A-Z])/g, '$1 $2'); // turns MobileNo -> Mobile No
    }

    const convertFieldName = (str) => {
        let second = str.slice(1);
        if (str.includes('ID')) {
            second = str.slice(1).replace('ID', 'Id');
        }
        return str.charAt(0).toLowerCase() + second
    }

    const checkLowerFieldName = (str) => {
        return str.toLowerCase();
    }

    useEffect(() => {
        getDirectTeam();
    }, []);

    return (
        <Layout>
            <main>
                <div className="pageWrapper maxWidth pt-0">
                    <div className="container-fluid form-cus-label">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="desktop-card card">
                                    <div className="card-header mb-3">
                                        <h5> Direct Team </h5>
                                    </div>
                                    {/* filters */}
                                    <div className="mx-md-3 mx-0 table-filter"
                                        style={{
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                                            gap: '14px'
                                        }}
                                    >
                                        <div>
                                            <label className="form-label">From Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fromDate || moment(new Date()).format(("YYYY-MM-DD"))}
                                                onChange={(e) => setFromDate(e.target.value)}
                                            />
                                        </div>
                                        <div>
                                            <label className="form-label">To Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={toDate || moment(new Date()).format(("YYYY-MM-DD"))}
                                                min={fromDate}
                                                onChange={(e) => setToDate(e.target.value)}
                                            />
                                        </div>
                                        <div>
                                            <label className="form-label">Status</label>
                                            <select className="form-select"
                                                value={status}
                                                onChange={(e) => setStatus(e.target.value)}
                                            >
                                                <option value="All">All</option>
                                                <option value="Active">Active</option>
                                                <option value="DeActive">DeActive</option>
                                                <option value="InActive">InActive</option>
                                            </select>
                                        </div>
                                        <div className="d-flex-end">
                                            <button
                                                type="button"
                                                onClick={getDirectTeam}
                                                className="cus-btn-submit"
                                            >Search</button>
                                        </div>
                                    </div>
                                    {/* records */}
                                    <div className="desktop-view-only card-body px-0">
                                        {
                                            directTeam?.length > 0 ? (
                                                <div className="table-responsive">
                                                    <table className="table align-middle mb-0 bg-hover-effect">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">#</th>
                                                                {
                                                                    directTeam[0].displayField.split(',').map((field) => (
                                                                        <th scope="col" key={field} className="text-nowrap">
                                                                            {formatFieldLabel(field)}
                                                                        </th>
                                                                    ))
                                                                }
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                directTeam?.map((el, i) => (
                                                                    <tr key={i}>
                                                                        <td>{i + 1}</td>
                                                                        {
                                                                            el.displayField.split(',').map((field) => (
                                                                                <td key={field}>
                                                                                    <p
                                                                                        className={`mb-0 f-w-500 ${field.toLowerCase() == 'status' ? (' badge text-white' + (el[convertFieldName(field)].toLowerCase() == 'active' ? ' bg-success' : ' bg-danger')) : ''}`}
                                                                                    >
                                                                                        {field.toLowerCase() == 'userid' ? el.pPrefix : ''}
                                                                                        {el[convertFieldName(field)] ?? el[checkLowerFieldName(field)]}
                                                                                    </p>
                                                                                </td>
                                                                            ))
                                                                        }
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div>
                                                    <p className="text-center">No records found.</p>
                                                </div>
                                            )}
                                    </div>
                                    <div className="mobile-view-only">
                                        {directTeam?.length > 0 ? (
                                            directTeam.map((el, i) => (
                                                <div key={i} className="card mb-3 p-3 bg-hover-effect rounded shadow-sm">
                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                        <span className="badge bg-dark">#{i + 1}</span>
                                                        {/* <small className=""></small> */}
                                                    </div>

                                                    {
                                                        el.displayField.split(',').map((field) => (
                                                            <div key={field} className="d-flex justify-content-between align-items-center my-1">
                                                                <strong>{formatFieldLabel(field)}: </strong>
                                                                <p
                                                                    className={`mb-0 f-w-500 ${field.toLowerCase() == 'status' ? (' badge text-white' + (el[convertFieldName(field)].toLowerCase() == 'active' ? ' bg-success' : ' bg-danger')) : ''}`}
                                                                >
                                                                    {field.toLowerCase() == 'userid' ? el.pPrefix : ''}
                                                                    {el[convertFieldName(field)] ?? el[checkLowerFieldName(field)]}
                                                                </p>
                                                            </div>
                                                        ))
                                                    }

                                                    {/* <div className="d-flex justify-content-between align-items-center my-2">
                                                        <strong>Purchased Products:</strong>
                                                        <span className="badge bg-success text-white">{el.purchasedProducts}</span>
                                                    </div> */}
                                                </div>
                                            ))
                                        ) : (
                                            <p className="text-center">No records found.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Layout >
    )
}

export default DirectTeam;